import React from "react";


interface DotsBackgroundProps {
  darkMode?: boolean;
}

const DotsBackground: React.FC<DotsBackgroundProps> = ({ darkMode }) => (
  <div
    className="fixed inset-0 z-0 pointer-events-none"
    style={{
      backgroundImage: darkMode
        ? "radial-gradient(circle, #374151 1.5px, transparent 1.5px), radial-gradient(circle, #374151 1.5px, transparent 1.5px)"
        : "radial-gradient(circle, #d1d5db 1.5px, transparent 1.5px), radial-gradient(circle, #d1d5db 1.5px, transparent 1.5px)",
      backgroundSize: "32px 32px",
      backgroundPosition: "0 0, 16px 16px",
      minHeight: "100vh",
      width: "100vw",
    }}
  />
);

export default DotsBackground;
